var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",class:'box_'+_vm.from},[_c('span',{staticClass:"th cursor",on:{"click":_vm.open}}),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"coinex-toast"},[_c('span',[_vm._v("这里的金币只是本节课所获取的哦")]),_vm._v(" "),_c('i',{staticClass:"cursor",on:{"click":_vm.close}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ad7a01","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/coinex.vue
// module id = null
// module chunks = 